<div
  class="content"
  [class.home]="isHomePage()"
  [@homeAnimations]="outlet?.activatedRouteData?.['animation']"
>
  <router-outlet #outlet="outlet"/>
</div>
